import AutoComplete from "./components/inputs/AutoComplete";
import {flare} from "@flareapp/flare-client";
import {flareVue} from "@flareapp/flare-vue";
import i18n from "./lang.js";


import {createApp} from 'vue';
import App from './components/App.vue'
import ModeSwitch from "./components/ModeSwitch";
import Disclaimer from "./components/ReApplyDisclaimer";
import ReApplyButton from "./components/ReApplyButton";
import SmsNotification from "./components/SmsNotification";
import MyError from "./components/ErrorComponent";
import MyTooltip from "./components/TooltipComponent";
import Questions from "./components/Questions";
import Application from "./components/Application";
import DashboardComponent from "./components/DashboardComponent";
import Business from "./components/Business";
import CommunicationFeeds from "./components/CommunicationFeedComponent";
import LangMenu from "./components/LangMenu";
import Text from "./components/inputs/Text";
import DateInput from "./components/inputs/DateInput";
import Loan from "./components/inputs/Loan";
import MyFile from "./components/inputs/File";
import Radio from "./components/inputs/Radio";
import Shareholders from "./components/inputs/Shareholders";
import Location from "./components/inputs/Location";
import MultiSelect from "./components/inputs/MultiSelect";
import AllQuestions from "./components/AllQuestions";
import AllDocuments from "./components/AllDocuments";
import Picture from "./components/inputs/Picture";
import Social from "./components/inputs/Social";
import FileIO from "./components/inputs/FileIO";
import MyNumber from "./components/inputs/Number";
import FooterAction from "./components/FooterAction";
import Notification from './components/Notification'

import MobilePanel from './components/MobilePanel'
import DesktopPanel from './components/DesktopMenu'

require('./bootstrap');
require('alpinejs');


flare.light(process.env.MIX_FLARE_KEY);

const app = createApp({})
app.use(flareVue)
app.directive('focus', {
    mounted(el) {
        el.focus()
    }
})

app.mixin({
    methods: {
        asset: function (path) {
            return `${process.env.MIX_ASSET_URL}/${path}`
        },
    },
})
app.component('App', App)
app.component('all-questions', AllQuestions)
app.component('footer-action', FooterAction)
app.component('mobile-panel', MobilePanel)
app.component('desktop-panel', DesktopPanel)
app.component('apply-disclaimer', Disclaimer)
app.component('reapply-button', ReApplyButton)
app.component('communication-feeds', CommunicationFeeds)
app.component('error-modal', MyError)
app.component('sms-modal', SmsNotification)
app.component('tooltip-modal', MyTooltip)
/*app.component('dashboard', Dashboard)*/
app.component('all-documents', AllDocuments)
app.component('mode-switch', ModeSwitch)
app.component('input-text', Text)
app.component('input-date', DateInput)
app.component('input-loan', Loan)
app.component('input-number', MyNumber)
app.component('my-notification', Notification)
app.component('input-file', MyFile)
app.component('input-fileio', FileIO)
app.component('input-autocomplete', AutoComplete)
app.component('input-social', Social)
app.component('input-picture', Picture)
app.component('input-multi', MultiSelect)
app.component('input-radio', Radio)
app.component('input-shareholders', Shareholders)
app.component('input-location', Location)
app.component('questions', Questions)
app.component('application', Application)
app.component('dashboard', DashboardComponent)
app.component('business', Business)
app.component('lang-menu', LangMenu)


app.use(i18n).mount("#app")
